import React from 'react'
import Text from '../../components/text/Text'
import lockImage from '../../assets/icons/big-lock-image.png'

const ChangePassword = () => {
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ marginRight: 24 }}>
                    <Text
                        label="Cambio de clave amiPOS"
                        color="#184287"
                        fontSize={36}
                        fontFamily={'Montserrat'}
                        fontWeight={600}
                    />
                    <Text
                        label={
                            'Para cambios de clave para tu comercio\nte derivaremos a nuestro centro de ayuda'
                        }
                        color="#464646"
                        fontSize={22}
                        fontFamily={'Montserrat'}
                        fontWeight={400}
                        marginTop={27}
                        marginBottom={16}
                    />
                    <div
                        style={{
                            display: 'flex',
                            backgroundColor: '#0086D6',
                            height: 42,
                            width: 214,
                            borderRadius: 4,
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: `
												0px 1px 5px 0px rgba(0, 0, 0, 0.12),
												0px 2px 2px 0px rgba(0, 0, 0, 0.14),
												0px 3px 1px -2px rgba(0, 0, 0, 0.20)
											`,
                        }}
                        className="pointer"
                        onClick={() => {
                            window.zE('messenger', 'open')
                        }}
                    >
                        <Text
                            label={'Ir a chat de ayuda'}
                            color="white"
                            fontSize={16}
                            fontFamily={'Montserrat'}
                            fontWeight={600}
                        />
                    </div>
                </div>
                <img src={lockImage} height={368} width={412} />
            </div>
        </div>
    )
}

export default ChangePassword
